//export const URL = 'http://intranet_mundorecarga_backend.com/api'
export const URL = 'https://api2.coinfru.com/api'

// server test-04
//export const URL = 'https://intranet-test-api.movileuros.com/api'
